import { graphql } from '../../graphql/generated';

export const USER_MENU_QUERY = graphql(`
  query UserMenu($doctorId: ID!) {
    doctor(id: $doctorId) {
      id
      name
      disabled
    }

    assignmentForCurrentUser {
      id
      primaryDoctor {
        id
      }
      additionalDoctors {
        id
      }
    }
  }
`);
